import React from 'react'

function Successpage() {
  return (
    <div>Successpage</div>
  )
}

export default Successpage